export default __webpack_public_path__ + "static/media/ssl-img.dd09a1ee.svg";